import { deltaToMarkdown } from 'quill-delta-to-markdown';
import markdownConverters from './markdownConverters';

export default (content) => {
  let markdown = content;

  markdown = deltaToMarkdown(content.ops, markdownConverters);
  markdown = markdown.replaceAll('\n```\n```', '');

  markdown = markdown.trim();

  return markdown;
};
